import client from 'core/axios';

export const populateViewed = status => ({
  type: 'WELCOME_WIDGET/POPULATE_NEED_MARK_VIEWED',
  status,
});

export const populateState = data => ({
  type: 'WELCOME_WIDGET/POPULATE_STATE',
  data,
});

export const markWelcomeWidgetViewed = () => async dispatch => {
  try {
    const { status } = await client.post(`v1/sl_users/welcome-widget/`);
    if (status === 201) return dispatch(populateViewed(true));
  } catch (e) {
    console.warn('could not mark all seen', e);
  }

  return null;
};

export const getWelcomeWidget = () => async dispatch => {
  try {
    const { status, data } = await client.get(`v1/sl_users/welcome-widget/`);
    if (status === 200) {
      dispatch(populateState(data));
    }
  } catch (e) {
    console.warn('could not get welcome widget', e);
  }
  return null;
};
